<template>
  <div id="hints" class="hints noselect section-container">
    <div class="d-flex justify-space-between">
      <header-title-two :loading="isLoading" title="Navigational Helpful Hints" />
      <template v-if="hints.length > 0">
        <previous-next-navigation
          :navIndex="hintsSlide"
          :navLast="hints.length - numberOfSlides"
          v-on:on-prev="onNav('prev')"
          v-on:on-next="onNav('next')"
          class-name="align-center tech-nav justify-end"
        />
      </template>
    </div>
    <div class="hints-content">
      <skeleton-card-list
        direction="horizontal"
        type="media"
        :isCard="true"
        :withoutMedia="true"
        :number="numberOfSlides"
        :loading="isLoading"
        class="skeleton-helpful-hints flex-nowrap py-4"
      >
        <slick-carousel
          v-if="hints.length > 0"
          ref="slickCarousel"
          :itemsToShow="numberOfSlides"
          :settings="slickSettings"
          @afterChange="afterChange"
        >
          <card-four
            v-for="item in hints"
            v-bind:key="item.id"
            class=""
            :id="item.id"
            :tag="item.tag"
            :title="item.title"
            :description="item.description"
            :link="item.link"
          />
        </slick-carousel>
      </skeleton-card-list>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { HintsApi } from '@gslc/models';
import { openApiConfig } from '../../api/config';
import HeaderTitleTwo from '../../components/typography/header-title-2.vue';
import CardFour from '../../components/cards/card-4.vue';
import SkeletonCardList from '../../components/skeleton/CardList.vue';
import SlickCarousel from '../../components/carousel/SlickCarousel.vue';
import PreviousNextNavigation from '../../components/PreviousNextNavigation.vue';
import { defaultSlickSettings, getNumberOfSlides } from '../../utils/carousel';

const config = openApiConfig();

const hintsApi = new HintsApi(config);

export default {
  name: 'HomeHelpfulHints',
  components: {
    HeaderTitleTwo,
    CardFour,
    SkeletonCardList,
    SlickCarousel,
    PreviousNextNavigation,
  },
  data: () => ({
    mainPlatformLink: process.env.VUE_APP_MAIN_PLATFORM_LINK,
    isLoading: false,
    hintsSlide: 0,
    slickSettings: defaultSlickSettings([4, 3.5, 2, 2, 1.2]),
  }),
  computed: {
    ...mapGetters(['hints', 'windowWidth']),
    numberOfSlides () {
      return getNumberOfSlides(this.windowWidth, [1.2, 2, 2, 3.5, 4]);
    },
  },
  mounted() {
    this.fetchHints();
  },
  methods: {
    ...mapActions(['refreshHints']),
    async fetchHints() {
      this.isLoading = true;
      const accessToken = await this.$auth.getTokenSilently();
      const hints = await hintsApi
        .getNavigationalHelpfulHints({
          headers: { Authorization: `Bearer ${accessToken}` },
        })
        .catch(e => console.error(e));
      this.refreshHints(hints?.data?.data ?? []);
      this.isLoading = false;
    },
    afterChange(slideNumber) {
      this.hintsSlide = slideNumber;
    },
    onNav(type) {
      switch (type) {
        case 'prev':
          this.$refs.slickCarousel.$children[0].prev();
          break;
        case 'next':
        default:
          this.$refs.slickCarousel.$children[0].next();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.hints-content {
  display: flex;
  // overflow: auto;
  margin-left: -8px;
  width: calc(100% + 8px);
}
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>
